export enum RequestFormRoutePaths {
  Summary = 'summary',
  Workflows = 'workflows',
  Goods = 'goods',
  Devices = 'devices',
  Files = 'files',
  Comments = 'comments',
  Address = 'actual-delivery-address',
  Ratings = 'ratings',
  DealDetails = 'deal-details',
  Status = 'status',
  OBD = 'obd',
  Inspection = 'inspection',
  QC = 'quality-control',
  Common = 'common',
}

export const RequestFormTabTitlesTranslateKeys = {
  [RequestFormRoutePaths.Summary]: 'summary',
  [RequestFormRoutePaths.Status]: 'status',
  [RequestFormRoutePaths.DealDetails]: 'deal_details',
  [RequestFormRoutePaths.Address]: 'address',
  [RequestFormRoutePaths.Common]: 'common',
  [RequestFormRoutePaths.Ratings]: 'ratings',
  [RequestFormRoutePaths.Comments]: 'comments',
  [RequestFormRoutePaths.Goods]: 'goods',
  [RequestFormRoutePaths.Devices]: 'devices',
  [RequestFormRoutePaths.Files]: 'files',
  [RequestFormRoutePaths.OBD]: 'obd',
  [RequestFormRoutePaths.Inspection]: 'inspection',
  [RequestFormRoutePaths.QC]: 'quality_control',
  [RequestFormRoutePaths.Workflows]: 'workflows',
};
